import { gql } from '@apollo/client'

export const loginAsUser = gql`
  query LoginAsUser {
    loginAsUser
  }
`
